import { Image } from 'expo-image';
import { View } from 'react-native';

import { type RadioCircleIndicatorProps, RadioGroup, Text, XStack } from '@fhs/ui';

import { BORDER_RADIUS } from './constants';
import { listStyles } from './shared-styles';
import type { ListItemType } from './types';
import { optimizeSanityImageUri } from './utils';

type ListItemRadioProps = ListItemType & {
  disabled?: boolean;
  value: string;
  indicatorSize?: RadioCircleIndicatorProps['size'];
};

export function ListItemRadio({
  indicatorSize = 'sm',
  minHeightStyle = 'static',
  ...props
}: ListItemRadioProps) {
  return (
    <RadioGroup.Item
      value={props.value}
      label={[props.title, props.subtitle].filter(Boolean).join(' - ')}
    >
      <RadioGroup.Pressable
        style={[
          listStyles.item,
          minHeightStyle === 'static' && listStyles.minHeightStyleStatic,
          props.isLastItem && listStyles.lastItem,
        ]}
        hoveredStyle={listStyles.itemHover}
        borderTopLeftRadius={props.isFirstItem ? BORDER_RADIUS : 0}
        borderTopRightRadius={props.isFirstItem ? BORDER_RADIUS : 0}
        borderBottomLeftRadius={props.isLastItem ? BORDER_RADIUS : 0}
        borderBottomRightRadius={props.isLastItem ? BORDER_RADIUS : 0}
      >
        {props.image?.asset?.uri && (
          <Image
            contentFit="contain"
            style={listStyles.image}
            alt={props.image.altText}
            source={{ uri: optimizeSanityImageUri(props.image.asset.uri) }}
            placeholder={{ blurhash: props.image.asset.blurHash }}
          />
        )}
        <View style={listStyles.titleTextContainer}>
          <View>
            <Text.Ui weight={props.titleFontWeight ?? 'semibold'} size="md" numberOfLines={1}>
              {props.title}
            </Text.Ui>
          </View>
          {Boolean(props.subtitle) && (
            <View>
              <Text.Ui size="sm" numberOfLines={1} style={listStyles.subtitle}>
                {props.subtitle}
              </Text.Ui>
            </View>
          )}
        </View>
        <XStack style={listStyles.indicatorWithTextWrapper}>
          {Boolean(props.indicatorText) && (
            <Text.Ui size="sm" numberOfLines={1} style={listStyles.indicatorText}>
              {props.indicatorText}
            </Text.Ui>
          )}
          <RadioGroup.CircleIndicator size={indicatorSize} />
        </XStack>
      </RadioGroup.Pressable>
    </RadioGroup.Item>
  );
}
